import type { ReactNode } from "react";

export type InlineNoticeTone = "info" | "warn" | "risk" | "ok";

const TONE_STYLES: Record<
  InlineNoticeTone,
  { bg: string; ink: string; border: string }
> = {
  info: {
    bg: "var(--info-soft)",
    ink: "var(--info-soft-ink)",
    border: "var(--info)",
  },
  warn: {
    bg: "var(--warn-soft)",
    ink: "var(--warn-soft-ink)",
    border: "var(--warn)",
  },
  risk: {
    bg: "var(--risk-soft)",
    ink: "var(--risk-soft-ink)",
    border: "var(--risk)",
  },
  ok: {
    bg: "var(--ok-soft)",
    ink: "var(--ok-soft-ink)",
    border: "var(--ok)",
  },
};

export function InlineNotice({
  tone = "info",
  children,
}: {
  tone?: InlineNoticeTone;
  children: ReactNode;
}) {
  const toneStyles = TONE_STYLES[tone];
  return (
    <div
      role={tone === "risk" ? "alert" : "status"}
      style={{
        padding: "10px 12px",
        borderRadius: "var(--r-sm)",
        border: `1px solid ${toneStyles.border}`,
        background: toneStyles.bg,
        color: toneStyles.ink,
        fontSize: 13,
        marginBottom: 12,
      }}
    >
      {children}
    </div>
  );
}
